module.exports = __webpack_public_path__ + "static/media/cashoutSFX.efdc6924.mp3";